import { ZoomPreset } from './types';

/**
 * Default font sizes
 */
export const fontSizeValue = 16;
export const fontSizePx = `${fontSizeValue}px`;

// Applies to the PDF font point size
export const pdfPointSizeValue = 9;

/**
 * Defines a text-scaling factor between the previe page and a PDF page. Since
 * the size of an A4 page is fixed, this allows us to scale the page dimensions
 * for the preview page correctly.
 *
 * 12px on screen should match 9pt in PDF exactly.
 */
export const ScalingFactor = fontSizeValue / pdfPointSizeValue;

/**
 * Default A4 page dimensions - these are used to proportionally place elements
 * on A4 size pages based on the element sizes
 */
export const PortraitA4 = {
  width: 595,
  height: 842,
};

/**
 * These are the dimensions used for the page preview components. They allow us
 * to equate 12px on screen to 9pt in PDF (scale by 0.75)
 *
 * This is in the portrait orientation
 */
export const PortaitPreview = {
  width: PortraitA4.width * ScalingFactor,
  height: PortraitA4.height * ScalingFactor,
};

/**
 * Percentage ratio of the height of an A4 page to its width. This imposes a
 * maximum value of the element width as well as the element 'y' value on a page
 *
 * It comes to about 141.5
 */
export const RatioA4 = (PortraitA4.height / PortraitA4.width) * 100;

/**
 * Useful graph ratios based on APC page: width / height
 */
export const HumanBody = 266 / 320;
export const BodyCompositionPie = 264 / 378;
export const MetabolicFingerprint = 1080 / 540;
export const MetabolicCapacities = 1080 / 679;
export const MetabolicCapacityChart = 216 / 228;
export const LoadCharacteristicsCharts = 1018 / 1370;

export const ZOOM_PRESETS: readonly ZoomPreset[] = [
  { label: '100%', value: 1.0, tooltip: 'Actual size' },
  { label: '125%', value: 1.125, tooltip: 'Zoom +1' },
  { label: '125%', value: 1.25, tooltip: 'Zoom +2' },
  { label: '125%', value: 1.35, tooltip: 'Zoom +3' },
  { label: '150%', value: 1.5, tooltip: 'Maximum zoon' },
] as const;

export const DEFAULT_ZOOM = 1.0;
export const MIN_ZOOM = 1.0;
export const MAX_ZOOM = 1.5;

export const ActiveTemplateLocalStorageKey = 'ACTIVE_TEMPLATE';

export const TrainingZoneDefaluts: Record<'Prod' | 'Test' | 'Dev' | 'Local', Record<string, number>> = {
  Prod: {
    swimming_freestyle: 4411,
    cycling: 99,
    running: 100,
    skating: 4415,
    football: 4416,
    triathlon_running: 123,
    triathlon_cycling: 124,
    swimming_backstroke: 4412,
    swimming_butterfly: 4414,
    swimming_breaststroke: 4413,
    rowing_ergometer: 4433,
    vq_cycling: 4419,
    kajak: 4418,
    xc_ski_uphill_running: 4420,
    roller_skating: 4421,
    triathlon_swimming: 4432,
    handcycling: 4422,
    kajak_speed: 4417,
    ice_skating: -1, // missing
    ski_roller_treadmill: 4423,
    running_stryd: -1, // missing
    nordic_combined_treadmill: -1,
    xc_ski: 4424,
    ski_alpin_rad: 1635,
    trail_running: 4425,
  },
  Test: {},
  Dev: {},
  Local: {},
};

// File uploads
export const MAX_FILE_SIZE_MB = 5;
export const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const HIDE_IMAGE_SENTINEL = -2;
export const USE_DEFAULT_SENTINEL = -3;
